<template>
  <div>
    <b-table
      responsive
      :items="items"
      :fields="fields"
    >
      <!-- A custom formatted price column -->
      <template #cell(amount)="data">
        {{ data.value | numberFormat }}
      </template>
      <!-- A custom formatted status column -->
      <template #cell(status)="data">
        <display-status
          :value="data.value"
          :text="data.item.display_status"
        />
      </template>
      <!-- A custom formatted expire_at column -->
      <template #cell(expire_at)="data">
        <display-date-time :value="data.value" />
      </template>
      <!-- A custom formatted action column -->
      <template #cell(action)="data">
        <b-button
          v-if="$can('update', 'discount.codes')"
          variant="flat-success"
          size="sm"
          class="btn-icon rounded-circle"
          @click="editButtonClicked(data.item)"
        >
          <feather-icon icon="Edit2Icon" />
        </b-button>
        <b-button
          v-if="$can('delete', 'discount.codes')"
          variant="flat-danger"
          size="sm"
          class="btn-icon rounded-circle"
          @click="deleteButtonClicked(data.item)"
        >
          <feather-icon icon="TrashIcon" />
        </b-button>
      </template>
    </b-table>
    <div
      v-if="!items.length"
      class="d-flex justify-content-center align-items-center"
    >
      <h6 class="font-weight-bolder mb-0">
        {{ $t("There are no discount codes to display") }}
      </h6>
    </div>
    <discount-codes-edit-modal
      :form="editForm"
      :additional-data="additionalData"
      @onHideModal="resetEditForm"
    />
  </div>
</template>

<script>
import { ListTable } from '../../../../common/mixins/list'
import DiscountCodesEditModal from '../edit/DiscountCodesEditModal'

export default {
  name: 'DiscountCodesList',
  components: { DiscountCodesEditModal },
  mixins: [ListTable],
  data() {
    return {
      routeName: 'discount-codes',
    }
  },
}
</script>

<style scoped>

</style>
